import script from "./NewNFTs.vue?vue&type=script&setup=true&lang=js"
export * from "./NewNFTs.vue?vue&type=script&setup=true&lang=js"

import "./NewNFTs.vue?vue&type=style&index=0&id=55651ae7&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55651ae7"]])

export default __exports__